var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { polygon, point } from "@turf/helpers";
import { logger } from "../index";
export function serviceDeliveryValidateCoords(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { googleMapsClient, zones } = args;
        const result = yield googleMapsClient.distance_matrix({
            destinations: [new google.maps.LatLng(args.lat, args.lng)],
            origins: [new google.maps.LatLng(args.fromLat, args.fromLng)],
            avoidHighways: args.avoid_highways,
            avoidTolls: args.avoid_tolls,
            avoidFerries: true,
            travelMode: google.maps.TravelMode.DRIVING,
            region: "nz",
        });
        if (!result.rows[0] || !result.rows[0].elements || !result.rows[0].elements[0]) {
            return {
                valid: false,
                distance: 0,
                duration: 0,
                zoneMatch: undefined,
            };
        }
        const matrixResult = result.rows[0].elements[0];
        const distance = matrixResult.distance.value;
        const duration = matrixResult.duration.value;
        /*
          // const from: T.Mapbox.CoordinatePointArray = [l.map_data.lng, l.map_data.lat];
        let exclude = "ferry";
        if (service.avoid_highways) {
          exclude = "motorway";
        }
        if (service.avoid_tolls) {
          exclude = "toll";
        }
        const result = await MapboxAPI.directions("mapbox/driving-traffic", from, to, {
          exclude: exclude,
          overview: "false",
        });
        if (result.code !== "Ok") {
          return {
            valid: false,
            distance: 0,
            driving_time: 0,
            zoneMatch: undefined,
          };
        }
        const { distance, duration } = result.routes[0];
        */
        let zoneMatch;
        let valid = false;
        const max_distance = (args.max_distance_km || 0) * 1000;
        const max_driving_time = (args.max_driving_time_min || 0) * 60;
        if (zones.length > 0) {
            const destinationPoint = point([args.lng, args.lat]);
            for (const zone of zones) {
                const polygonCoordinates = zone.polygon.coordinates[0];
                console.log(`${zone.name}`, zone);
                const zonePolygon = polygon([
                    // zone.polygon.map((p) => ([p.lng, p.lat]))
                    polygonCoordinates,
                ]);
                const inZone = booleanPointInPolygon(destinationPoint, zonePolygon);
                if (inZone) {
                    zoneMatch = zone;
                    valid = true;
                    break;
                }
            }
        }
        else {
            if (max_distance === 0 && max_driving_time === 0) {
                valid = true;
            }
            else if (max_distance === 0 && duration <= max_driving_time) {
                valid = true;
            }
            else if (max_driving_time === 0 && distance <= max_distance) {
                valid = true;
            }
            else if (distance <= max_distance && duration <= max_driving_time) {
                valid = true;
            }
        }
        if (typeof args.log === "undefined" || args.log) {
            logger.info("MAX DISTANCE", max_distance);
            logger.info("MAX DRIVING", max_driving_time);
            logger.info("DISTANCE", distance);
            logger.info("DRIVING", duration);
            logger.info("ZONE", zoneMatch);
            logger.info("VALID", valid);
        }
        return { valid, zoneMatch, distance, duration };
    });
}
export function deliveryFormatTrackingLink(link) {
    // NEED TO REMOVE THIS LATER ON
    return link.replace("https://deliverytracking.booknorder.co.nz", "https://app.tookanapp.com");
}
//# sourceMappingURL=services.js.map